import { render, staticRenderFns } from "./ProductSyncLog.vue?vue&type=template&id=59871d31&scoped=true&"
import script from "./ProductSyncLog.vue?vue&type=script&lang=js&"
export * from "./ProductSyncLog.vue?vue&type=script&lang=js&"
import style0 from "./ProductSyncLog.vue?vue&type=style&index=0&id=59871d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59871d31",
  null
  
)

export default component.exports